// extracted by css-extract-rspack-plugin
export default {"fieldStack":"fieldStack-gTt2Nd"};